import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};

  ${({ additionalstyle }) => additionalstyle};
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  height: 100%;
`;

export const Content = styled.div`
  width: 500px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  .text {
    color: ${colors.white};
    margin: 25px 0 15px 0;
  }

  .list {
    margin-bottom: 20px;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 16px;
  margin: 24px 0 0 0;
`;

export const StatusContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  height: 100%;
  border: 1px solid ${colors.darkGrey};
  margin-top: 24px;

  .overall {
    .statusTitle {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      column-gap: 16px;

      .status {
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 2px;
        color: ${colors.charcoal};
      }
    }
  }

  .details {
    width: 150px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    row-gap: 8px;
    
    .statusTitle {
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      column-gap: 8px;
      .status {
        font-size: 12px;
        font-weight: 300;
        color: ${colors.charcoal};
      }
    }
  }

  .statusDot {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid ${colors.dimGrey};
  }

  .large {
    width: 32px;
    height: 32px;
  }

  .success {
    background-color: ${colors.green};
  }

  .failed {
    background-color: ${colors.red};
  }

`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-top: 24px;

  .buttonContainer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;
